import React from 'react';
import { Segment } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ClaimFormContainer from '../ClaimForm';
import Content from '../Content';
import PathView from '../PathView';
import DocumentTitle from '../DocumentTitle';
import * as messageActions from '../../actions/message-actions';
import store from '../../store/store';

const ClaimView = ({ actions, history, match }) => {
  const handleSubmit = () => {
    if (store.getState().authorization.role === 'transfer_claims') {
      return;
    }
    actions.showMessage({
      header: 'Success',
      text: 'Claim edited',
      props: { success: true },
      duration: 2000,
    });
    history.goBack();
  };

  return (
    <Content fullWidth>
      <DocumentTitle title={`Claim ${match.params.id}`} />
      <PathView
        paths={[
          { name: 'Claims', path: '/claims' },
          {
            name: match.params.id,
            path: `/claim/${match.params.id}`,
          },
          { name: 'Edit' },
        ]}
      />
      <Segment>
        <ClaimFormContainer onSubmit={handleSubmit.bind(this)} />
      </Segment>
    </Content>
  );
};

export default connect(null, (dispatch) => ({
  actions: bindActionCreators(messageActions, dispatch),
}))(withRouter(ClaimView));



// WEBPACK FOOTER //
// ./src/component/ClaimFormPage/index.js